import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getAccounting } from './accounting.selectors';

export const selectServicingCompanies = createSelector(
  getAccounting,
  ({ servicingCompanies }) => servicingCompanies,
);

const selectServicingCompaniesValues = createSelector(selectServicingCompanies, Object.values);

export const selectServicingCompaniesOptions = createSelector(
  selectServicingCompaniesValues,
  servicingCompanies =>
    servicingCompanies.map(company => ({ value: company.name, name: company.name })),
);

export const selectFilteredServicingCompanies = createSelector(
  getDebouncedSearchValue,
  selectServicingCompaniesValues,
  searchItems(servicingCompany => [servicingCompany.name]),
);
